import BillzTypography from 'components/BillzTypographies/BillzTypography';
import React from 'react';
import { HighlightBox } from '../HighlightBox/HighlightBox';

export const InvoiceEmailSendDescriptor = ({ sendEmail, emailToSend }) => {
    return (
        sendEmail === true ?         
        (<HighlightBox>
            <BillzTypography color={'black'}>Faktura wysłana na adres:</BillzTypography>
            <BillzTypography color={'black'}>{emailToSend}</BillzTypography>
        </HighlightBox>) : 
        (<React.Fragment />)
    );
  };